import React, { useState, useEffect } from "react";
import Tab1Image from "../img/envision/healthcare/energytabthree/securityenergy.jpg";
import Tab2Image from "../img/envision/energy/cards/energytab2cyber.jpg";
import { useNavigate } from "react-router-dom";
import Tab3Image from "../img/envision/energy/cards/energycyber.jpg";
import Tab4Image from "../img/envision/healthcare/energytabthree/energycloud.jpg";
import Tab5Image from "../img/envision/healthcare/energytabthree/energy -security.jpg";
// import Tab5Image from "../img/envision/energy/cards/energyconverstion";

const Energypagethirdtab = () => {
    const [activeTab, setActiveTab] = useState("tab1");
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    const handleKnowMoreClick = () => {
        // Navigate to the documentaerospacepage with the specific hash
        navigate("/documnetEnergyPage#documnetEnergyPageone");
    };
    const [isHovered, setIsHovered] = useState(false);
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
      };
    // Autoplay effect to change tabs every 3 seconds (3000ms)
   useEffect(() => {
       let tabInterval;
   
       if (!isHovered && isAutoPlayActive) {
         tabInterval = setInterval(() => {
           setActiveTab((prevTab) => {
             const nextTabNum = parseInt(prevTab.replace("tab", "")) % 5 + 1;
             return `tab${nextTabNum}`;
           });
         }, 3000);
       }
   
       return () => clearInterval(tabInterval);
     }, [activeTab, isHovered, isAutoPlayActive]);
   


    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            display: "flex",
            flexDirection: "row",
            width: "80%",
            margin: "50px auto",
            justifyContent: "space-between",
        },
        tabNav: {

            flexDirection: "column",
            borderRight: "1px solid #fff",
            // height: "350px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
        },
        // Apply mobile-specific styles for tabNav

        tabButton: {
            padding: "20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
            cursor: "pointer",
            height: "400px",
            overflowY: "auto",

        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
           height:"355px"
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        // Mobile styling for tabs above content
        mobileContainer: {
            flexDirection: "column", // Stack tabs and content
        },
        mobileTabNav: {
            flexDirection: "row", // Tabs are horizontal on mobile
            justifyContent: "space-around",
            borderRight: "none", // Remove right border for mobile
        },
        mobileCard: {
            flexDirection: "column", // Stack image and text content
            alignItems: "center",
            textAlign: "center",
        },
        mobileImage: {
            width: "100%",
            height: "auto",
            marginRight: "0", // Remove right margin on mobile
        },
        mobileKnowMoreButton: {
            marginLeft: "0", // Center button on mobile
        },
        // Mobile tab navigation change
        mobileTabButton: {
            padding: "20px",
            fontSize: "14px",
            fontWeight: "normal",
            color: "#555",
            backgroundColor: "#f0f0f0",
            border: "none",
            cursor: "pointer",
            outline: "none",
            textAlign: "center",
        },
        activeMobileTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        }
    };

    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}>AI-driven Energy </span> Management Systems
            </h1>

            <div style={{ ...styles.container, ...(window.innerWidth <= 768 ? styles.mobileContainer : {}) }} className="tabclass-container-data">
                {/* Tab Navigation */}
                <div style={{ ...styles.tabNav, ...(window.innerWidth <= 768 ? styles.mobileTabNav : {}) }} className="tabdata">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        SECURED & MODERN INFRASTRCUTURE
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        ROBUST DISASTER RECOVERY &amp; BUSINESS CONTINUITY
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab3") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab3") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        TRANSFORMED APPLICATIONS E.g. ERP Transformation
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab4")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab4") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab4") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        CLOUD ADOPTION
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab5" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab5")}
                        className="tab-button-width"
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab5") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab5") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        BUSINESS ALIGNED IT & SECURITY
                    </button>


                </div>

                {/* Tab Content */}
                <div style={{ ...styles.card, ...(window.innerWidth <= 768 ? styles.mobileCard : {}) }} onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image, }[activeTab]}
                        alt="Aerospace"
                        style={{ ...styles.image, ...(window.innerWidth <= 768 ? styles.mobileImage : {}) }}
                    />
                    <div style={styles.textContent}>
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    "<strong>Problem:</strong>",
                                    "Legacy infrastructure with security vulnerabilities",
                                    "Increasing cyber threats targeting network infrastructure",
                                    "Scalability and performance bottlenecks",
                                    "Compliance challenges in data protection and privacy",
                                    "<strong>How DREBCON Can Help:</strong>",
                                    "Implement Zero Trust Security models to enhance protection",
                                    "Design and deploy AI-driven, self-healing networks",
                                    "Upgrade infrastructure with SD-WAN, 5G, and edge computing",
                                    "<strong>Result:</strong>",
                                    "Enhanced security posture and reduced attack surface",
                                    "Improved network performance and reliability",
                                    "Regulatory compliance and reduced legal risks",
                                    "Scalable and future-ready infrastructure",
                                ],
                                [
                                    "<strong>Problem:</strong>",
                                    "Lack of a comprehensive Disaster Recovery (DR) and Business Continuity Plan (BCP)",
                                    "Downtime due to cyberattacks, natural disasters, or system failures",
                                    "Data loss risks with ineffective backup and recovery strategies",
                                    "<strong>How DREBCON Can Help:</strong>",
                                    "Develop and implement AI-powered disaster recovery solutions",
                                    "Design and deploy AI-driven, self-healing networks",
                                    "Upgrade infrastructure with SD-WAN, 5G, and edge computing",
                                    "<strong>Result:</strong>",
                                    "Reduced downtime and faster recovery from incidents",
                                    "Improved regulatory compliance and risk mitigation",
                                    "Continuous business operations with minimal disruption",
                                    "Cost-effective DR strategies with optimized resource utilization",
                                ],
                                [
                                    "<strong>Problem:</strong>",
                                    "Legacy ERP and business integration challenges between communication networks and IT systems",
                                    "High maintenance costs for outdated software",
                                    "Need for real-time data processing and analytics",
                                    "<strong>How DREBCON Can Help:</strong>",
                                    "Modernize ERP systems with AI, automation, and cloud-native solutions",
                                    "Implement API-driven architectures for seamless integration",
                                    "Upgrade infrastructure with SD-WAN, 5G, and edge computing",
                                    "<strong>Result:</strong>",
                                    "Increased operational efficiency and cost savings",
                                    "Future-ready, scalable IT systems",
                                    "Improved customer experience and service delivery",
                                    "Real-time visibility and decision-making support",
                                ],
                                [
                                    "<strong>Problem:</strong>",
                                    "Hesitation in migrating to cloud due to security and compliance concerns",
                                    "Costly and inefficient on-premises infrastructure",
                                    "Difficulty in managing multi-cloud environments",
                                    "Latency and performance issues for mission-critical applications",
                                    "<strong>How DREBCON Can Help:</strong>",
                                    "Provide cloud strategy and migration planning tailored to business needs",
                                    "Implement secure multi-cloud and hybrid cloud environments",
                                    "Upgrade infrastructure with SD-WAN, 5G, and edge computing",
                                    "<strong>Result:</strong>",
                                    "Cost savings with optimized cloud solutions",
                                    "Enhanced agility and scalability for business operations",
                                    "Secure and compliant cloud adoption",
                                    "Faster time-to-market for new services",
                                ],
                                [
                                    "<strong>Problem:</strong>",
                                    "Lack of a comprehensive Disaster Recovery (DR) and Business Continuity Plan (BCP)",
                                    "Downtime due to cyberattacks, natural disasters, or system failures",
                                    "Data loss risks with ineffective backup and recovery strategies",
                                    "Compliance mandates requiring resilient recovery mechanisms",
                                    "<strong>How DREBCON Can Help:</strong>",
                                    "Develop and implement AI-powered disaster recovery solutions",
                                    "Design and deploy AI-driven, self-healing networks",
                                    "Upgrade infrastructure with SD-WAN, 5G, and edge computing",
                                    "<strong>Result:</strong>",
                                    "Reduced downtime and faster recovery from incidents",
                                    "Improved regulatory compliance and risk mitigation",
                                    "Continuous business operations with minimal disruption",
                                ],
                            ];

                            // Ensure the selected content is within range and not undefined
                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((point, index) => (
                                <ul key={index}>
                                    <li dangerouslySetInnerHTML={{ __html: point }} />
                                </ul>
                            ));
                        })()}


                        <button
                            style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                            onClick={handleKnowMoreClick}
                            className="know-more-btn"
                        >
                            Know More
                        </button>
                    </div>
                </div>
            </div>

            {/* Dot Navigation for 3 Tabs */}
            <div style={styles.dotNav}>
                {[...Array(5)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Energypagethirdtab;
